import trackOne from '../../assets/audio/xDeviruchiExploringTheUnknownLoop.wav';

import { ImmerStateCreator } from './store.types';

type TOptionsState = {
   state: {
      backgroundMusicTrack: BackgroundMusicTrackPath;
      isBackgroundMusicTrackPlaying: boolean;
      backgroundMusicTrackVolume: number;
   };
};

type TOptionsActions = {
   actions: {
      setBackgroundMusicTrack(params: { track: BackgroundMusicTrackPath }): void;
      setBackgroundMusicTrackVolume(params: { volume: number }): void;
      playBackgroundMusic(): void;
      pauseBackgroundMusic(): void;
   };
};

type TOptionsSlice = TOptionsState & TOptionsActions;
export type TNamedOptionsSlice = { options: TOptionsSlice };

export const getOptionsInitialState = (): TOptionsState['state'] => {
   return {
      backgroundMusicTrack: BackgroundMusicTrackPath.TrackOne,
      isBackgroundMusicTrackPlaying: false,
      backgroundMusicTrackVolume: 1,
   };
};

export const createOptionsSlice: ImmerStateCreator<TNamedOptionsSlice, TOptionsSlice> = (set, get, store) => ({
   /***************************
    * State
    ***************************/
   state: getOptionsInitialState(),

   /***************************
    * Actions
    ***************************/
   actions: {
      setBackgroundMusicTrack(params: { track: BackgroundMusicTrackPath }): void {
         return set((state) => {
            state.options.state.backgroundMusicTrack = params.track;
         });
      },
      playBackgroundMusic(): void {
         return set((state) => {
            if (!get().options.state.isBackgroundMusicTrackPlaying) {
               state.options.state.isBackgroundMusicTrackPlaying = true;
            }
         });
      },
      pauseBackgroundMusic(): void {
         return set((state) => {
            state.options.state.isBackgroundMusicTrackPlaying = false;
         });
      },
      setBackgroundMusicTrackVolume(params: { volume: number }): void {
         return set((state) => {
            state.options.state.backgroundMusicTrackVolume = params.volume;
         });
      },
   },
});

export const BackgroundMusicTrackPath = {
   TrackOne: trackOne,
} as const;
export type BackgroundMusicTrackPath = (typeof BackgroundMusicTrackPath)[keyof typeof BackgroundMusicTrackPath];
